var Msg;
function getCookie(e) {
    var t = void 0;
    if (document.cookie.length > 0) {
        var a = document.cookie.indexOf(e + "=");
        if (-1 !== a) {
            a = a + e.length + 1;
            var n = document.cookie.indexOf(";", a);
            -1 === n && (n = document.cookie.length),
            "undefined" === (t = unescape(document.cookie.substring(a, n))) && (t = void 0),
            "null" === t && (t = null)
        }
    }
    return t
}
if(getCookie('locale') === "en_UK"){
    Msg = {
        navProps: ['IoT Architecture', 'Services and Advantages', 'About Us', 'Contact Us'],
        downLoad: 'DownLoad',
        cancel: 'Cancel',
        fkSuccess: "Feedback is successful. Thanks for your feedback",
        fkFail: "Feedback failed. Please try again",
        downNew: "Download the latest browser",
        downMsg: "The current browser version is too low. It is recommended to use the latest version of Google for the best experience. Click to download"
    };
}else{
    Msg = {
        navProps: ['物联网架构', '服务与优势', '关于我们', '联系我们'],
        downLoad: '下载',
        cancel: '取消',
        fkSuccess: "反馈成功！感谢您的反馈！",
        fkFail: "反馈失败！请重试！",
        downNew: "下载最新浏览器",
        downMsg: "当前浏览器版本过低，推荐使用谷歌最新版本浏览器已获得最佳体验， 点击下载"
    };
}


